var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "8.96 11.35 82.08 77.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m84.723 11.355h-69.449v0.003906c-3.4844 0.042969-6.3008 2.875-6.3164 6.3672v51.289c0.015625 3.4922 2.832 6.3242 6.3164 6.3711h12.926v10.887c0 0.88281 0.49219 1.6914 1.2773 2.0977 0.33984 0.17578 0.71094 0.26172 1.082 0.26172 0.48047 0 0.96094-0.14844 1.3672-0.4375l18.043-12.809h34.754c3.4883-0.046875 6.3008-2.8789 6.3164-6.3711v-51.289c-0.015624-3.4922-2.8281-6.3242-6.3164-6.3711z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconComment);
export default __webpack_public_path__ + "static/media/icon-comment.7df609c533cdf4f501792505201c1dfa.svg";
export { ForwardRef as ReactComponent };